module.exports = __webpack_public_path__ + "assets/f9adceef781b309a2ce01133e02310b6.png";